export default __webpack_public_path__ + "static/media/listUs trailer.cbbb387a.mp4";